import React from 'react';
import { useTranslation } from 'react-i18next';
import TranslationNamespaces from '../../locales/TranslationNamespaces';
import { useNavigate } from 'react-router-dom';
import { useApi } from '../../state/ApiContext';
import { useCache } from '../../state/CachingContext';
import CenteredQButton from '../Shared/CenteredQButton';
import FlexContainer from '../Shared/FlexContainers/FlexContainer';
import HeaderWithDescription from '../Shared/HeaderWithDescription';
import PageError from '../Shared/PageError';
import InvitationMessageBox from '../Shared/MessageBoxes/InvitationMessageBox';

const ConfirmInvitation = (): JSX.Element => {
  const namespace = TranslationNamespaces.login;
  const { t } = useTranslation(namespace);
  const { postRequest } = useApi();
  const { getCache, clearCache } = useCache();

  const [loading, setLoading] = React.useState(false);
  const [isCompleted, setIsCompleted] = React.useState(false);
  const [showErrorMessage, setShowErrorMessage] = React.useState(false);

  const navigate = useNavigate();
  const session = getCache();

  const cancel = (): void => {
    clearCache();
    navigate('/');
  };

  const confirm = async (): Promise<void> => {
    const invitationGuid = session.invitationguid;

    if (invitationGuid) {
      await postRequest('User/AcceptInvitation', { invitationGuid: invitationGuid }, setLoading)
        .then(() => setIsCompleted(true))
        .catch(() => setShowErrorMessage(true));
    } else {
      setShowErrorMessage(true);
    }
  };

  return (
    <>
      {!session.authData ? (
        <PageError code='500' message='noAuthData' translationNamespace={namespace} />
      ) : !isCompleted ? (
        showErrorMessage ? (
          <PageError code='500' message='confirmInvitationFailed' translationNamespace={namespace} />
        ) : (
          <>
            <HeaderWithDescription headerSuffix='ConfirmInvitation' translationNamespace={namespace}>
              <InvitationMessageBox />
            </HeaderWithDescription>

            <FlexContainer>
              <CenteredQButton onClick={confirm} isLoading={loading} color='secondary' fullWidth>
                {t('yes')}
              </CenteredQButton>

              <CenteredQButton variant='text' onClick={cancel}>
                {t('cancel')}
              </CenteredQButton>
            </FlexContainer>
          </>
        )
      ) : (
        <>
          <HeaderWithDescription headerSuffix='invitationCompleted' translationNamespace={namespace}>
            <InvitationMessageBox />
          </HeaderWithDescription>

          {/* <CenteredQButton color='secondary' onClick={() => ApiHelper.redirectToMyAtiQxID(authData)}>
            {t('ok')}
          </CenteredQButton> */}
        </>
      )}
    </>
  );
};

export default ConfirmInvitation;
